import AnimatedHero from "../UI/AnimatedHero";
import Button from "../UI/Button";
import styles from "./Header.module.css";
import Nav from "./Nav";

const Header = (props) => {
  return (
    <header id="header">
      <main>
        <AnimatedHero />
        <div className={styles.content}>
          <h1>
            Hello, I'm <span>Mohamed Magdy</span>
          </h1>
          <p className={styles.job}>
            I'm a <span>Full-Stack Web Developer</span>
          </p>
          <p className={styles.details}>I'm using MERN Stack Technologies</p>
          <div className={styles.buttonContainer}>
            <Button color="red" href="#portofolio">
              View my work
            </Button>
            <Button href="#contact">Contact</Button>
          </div>
        </div>
      </main>
      <Nav />
    </header>
  );
};

export default Header;
